export enum ANIMATION_CANVAS_STATE {
  INIT = 'INIT',
  GAME_LOADING = 'GAME_LOADING',
  ASSETS_LOADING = 'ASSETS_LOADING',
  READY = 'READY',
  DESTROYING = 'DESTROYING',
}

export enum ANIMATION_PLAY_STATE {
  READY = 'READY',
  GAME_LOADING = 'GAME_LOADING',
  PAUSED = 'PAUSED',
  PLAYING = 'PLAYING',
  FINISHED = 'FINISHED',
  CRASHED = 'CRASHED',
}
